import { loadVulnerabilityDetail } from 'store/Manage/actions';
import { newGetVulns } from 'store/Manage/filterActions';
import api from 'services/api';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { selectVulnDetail, selectVulnsList } from 'store/Manage/selectors';
import { trackEvent } from 'tracking/GA';
import { ACTIONS, CATEGORIES } from 'tracking/GA/constants';
import * as types from './types';

export const markDuplicatesSuccess = (updatedVulnList) => async (dispatch) => dispatch({ type: types.DUPLICATES_MARK_SUCCESS, updatedVulnList });
export const markAsMainSuccess = () => async (dispatch) => dispatch({ type: types.DUPLICATES_MARK_AS_MAIN_SUCCESS });
export const removeDuplicatesSuccess = () => async (dispatch) => dispatch({ type: types.DUPLICATES_REMOVE_SUCCESS });
export const getDuplicatesSuccess = (duplicates) => async (dispatch) => dispatch({ type: types.DUPLICATES_GET_SUCCESS, duplicates });
export const duplicatesError = (error) => async (dispatch) => dispatch({ type: types.DUPLICATES_ERROR, error });

export function getDuplicates (id) {
  return async (dispatch, getState) => {
    try {
      const currentWorkspace = selectCurrentWorkspace(getState());
      const duplicates = await api.manage.getVulnDuplicates(currentWorkspace, id);

      const orderedDuplicates = duplicates.sort((a, b) => {
        if (a.is_main && !b.is_main) return -1;
        if (!a.is_main && b.is_main) return 1;
        return a.id - b.id;
      });

      return dispatch(getDuplicatesSuccess(orderedDuplicates));
    } catch (error) {
      return dispatch(duplicatesError(error.message));
    }
  };
}

export function markDuplicates (duplicatesIDs, mainID = null) {
  return async (dispatch, getState) => {
    try {
      let main = null;
      let duplicates = [];

      if (mainID) main = mainID;
      else main = duplicatesIDs[0];

      duplicates = duplicatesIDs.filter((id) => id !== main);

      const currentWorkspace = selectCurrentWorkspace(getState());
      const vulnList = selectVulnsList(getState());

      const data = {
        main_vulnerability_id: main,
        associated_vulnerabilities_ids: duplicates
      };
      await api.manage.markDuplicates(currentWorkspace, data);
      dispatch(trackEvent(CATEGORIES.duplicates, ACTIONS.clickSetAsDuplicates.name, ACTIONS.clickSetAsDuplicates.label));

      const idsToUpdate = [main, ...duplicates];

      const updatedVulnsPromises = idsToUpdate.map((id) => api.manage.fetchById(currentWorkspace, id));
      const updatedVulns = await Promise.all(updatedVulnsPromises);

      const newVulnList = vulnList.map((vuln) => {
        const updatedVuln = updatedVulns.find((updated) => updated._id === vuln._id);
        if (updatedVuln) return updatedVuln;
        return vuln;
      });

      return dispatch(markDuplicatesSuccess(newVulnList));
    } catch (error) {
      return dispatch(duplicatesError(error.message));
    }
  };
}

export function removeDuplicate (duplicateID) {
  return async (dispatch, getState) => {
    try {
      const currentWorkspace = selectCurrentWorkspace(getState());
      const { id } = selectVulnDetail(getState());
      const data = {
        vulnerabilities_to_disassociate_ids: [duplicateID]
      };
      await api.manage.removeDuplicates(currentWorkspace, data);
      dispatch(newGetVulns());
      dispatch(getDuplicates(id));
      dispatch(loadVulnerabilityDetail(id));
      return dispatch(removeDuplicatesSuccess());
    } catch (error) {
      return dispatch(duplicatesError(error.message));
    }
  };
}

export function markAsMainDuplicate (newMainID) {
  return async (dispatch, getState) => {
    try {
      const currentWorkspace = selectCurrentWorkspace(getState());
      const data = {
        new_main_vulnerability_id: newMainID
      };
      await api.manage.markAsMainDuplicate(currentWorkspace, data);

      dispatch(newGetVulns());
      dispatch(getDuplicates(newMainID));
      dispatch(loadVulnerabilityDetail(newMainID));

      return dispatch(markAsMainSuccess());
    } catch (error) {
      return dispatch(duplicatesError(error.message));
    }
  };
}
